import React, { useMemo, useState } from "react";
// import "./ToolBar.css";

// Button Component
import ToolBarButton from "./buttons/ToolBarButton";

// Menu Components
import ToolbarMenu from "./menus/ToolbarMenu";

// Svg images
import toolbarIconLibrary from "./icons/ToolbarIconLibrary";

// Interfaces & Enums
import { MarkerType, MenuTypes } from "../enums";
import { ISystemData } from "../interfaces";

//Others
import { observer } from "mobx-react-lite";
import { useStores } from "index";

interface IToolBarProps {
  panTo: Function;
  selectedMarkerData: ISystemData | null | undefined;
  setSelectedMarkerId: Function;
  categorySelected: MenuTypes;
  setCategorySelected: Function;
  showMenu: boolean;
  setShowMenu: Function;
  lastSelectedMenuSystemRef: React.MutableRefObject<HTMLDivElement | null>;
}

const ToolBar: React.FC<IToolBarProps> = observer((props: IToolBarProps) => {
  const {
    panTo,
    selectedMarkerData,
    setSelectedMarkerId,
    categorySelected,
    setCategorySelected,
    showMenu,
    setShowMenu,
    lastSelectedMenuSystemRef,
  } = props;
  const { systemStore } = useStores();

  const [search, setSearch] = useState("");

  const menuProps = {
    selectedMarkerData,
    setSelectedMarkerId,
    search,
    setSearch,
    panTo,
    setShowMenu,
    lastSelectedMenuSystemRef,
  };

  const buttonTools = {
    categorySelected: categorySelected,
    setCategorySelected: setCategorySelected,
    setSelectedMarkerId: setSelectedMarkerId,
    setSearch: setSearch,
  };

  const buttons = [
    {
      icon: toolbarIconLibrary.buttonIcons.all,
      title: MenuTypes.All,
      numbersFromTop: 0,
      startFromBottom: false,
      buttonCategoryEnum: MenuTypes.All,
    },
    {
      icon: toolbarIconLibrary.buttonIcons.error,
      title: MenuTypes.Errors,
      numbersFromTop: 1,
      startFromBottom: false,
      showChip: true,
      buttonCategoryEnum: MenuTypes.Errors,
      chipBackgroundColor: "#EE1B34",
      chipTextColor: "white",
      chipCount: systemStore.criticals.length,
    },
    {
      icon: toolbarIconLibrary.buttonIcons.warning,
      title: MenuTypes.Warnings,
      numbersFromTop: 2,
      startFromBottom: false,
      showChip: true,
      buttonCategoryEnum: MenuTypes.Warnings,
      chipBackgroundColor: "#FE9800",
      chipTextColor: "white",
      chipCount: systemStore.warnings.length,
    },
    {
      icon: toolbarIconLibrary.buttonIcons.normal,
      title: MenuTypes.Normals,
      numbersFromTop: 3,
      startFromBottom: false,
      showChip: true,
      buttonCategoryEnum: MenuTypes.Normals,
      chipBackgroundColor: "#009900",
      chipTextColor: "white",
      chipCount: systemStore.normals.length,
    },
    {
      icon: showMenu
        ? toolbarIconLibrary.lightChevron.left
        : toolbarIconLibrary.lightChevron.right,
      title: showMenu ? "Collapse" : "Expand",
      numbersFromTop: 0,
      startFromBottom: true,
      showChip: false,
      buttonCategoryEnum: MenuTypes.Settings,
      highlightButton: showMenu,
      onClick: () => {
        setShowMenu(!showMenu);
      },
    },
  ];

  const menuSelection = (category: MenuTypes | null) => {
    if (!showMenu) return null;
    switch (category) {
      case MenuTypes.All:
        return (
          <ToolbarMenu
            menuProps={menuProps}
            menuChoices={{
              category: MenuTypes.All,
              title: "All (" + String(systemStore.all.length) + ")",
              showSearchBar: true,
              markers: systemStore.all,
            }}
          />
        );
      case MenuTypes.Errors:
        return (
          <ToolbarMenu
            menuProps={menuProps}
            menuChoices={{
              category: MenuTypes.Errors,
              title: String(systemStore.criticals.length) + " Critical Errors",
              showSearchBar: true,
              markers: systemStore.criticals,
            }}
          />
        );
      case MenuTypes.Warnings:
        return (
          <ToolbarMenu
            menuProps={menuProps}
            menuChoices={{
              category: MenuTypes.Warnings,
              title: String(systemStore.warnings.length) + " Warnings",
              showSearchBar: true,
              markers: systemStore.warnings,
            }}
          />
        );
      case MenuTypes.Normals:
        return (
          <ToolbarMenu
            menuProps={menuProps}
            menuChoices={{
              category: MenuTypes.Normals,
              title: String(systemStore.normals.length) + " Systems",
              showSearchBar: false,
              markers: systemStore.normals,
            }}
          />
        );
      /*
        case MenuTypes.SETTINGS:
            return (<ToolbarMenu toolVariables={toolVariables}
                menuChoices={{
                    category: MenuTypes.SETTINGS,
                    title: String(normalCount) + ' Systems',
                    showSearchBar: false,
                    markers: normalMarkers
                }}
            />);
            */
      default:
        return null;
    }
  };

  return (
    <div style={{ position: "absolute", top: "0px" }}>
      {menuSelection(categorySelected)}
      <span className="tool-bar">
        {buttons.map((buttonProps) => {
          return (
            <ToolBarButton
              key={"button-" + buttonProps.buttonCategoryEnum}
              buttonProps={buttonProps}
              buttonTools={buttonTools}
            />
          );
        })}
      </span>
    </div>
  );
});

export default ToolBar;
